import { OrderValidity, OrderType, ProductType, PlatformType, WidgetViewMode } from '../app.structs';
import { environment } from '../../environments/environment';
import { utradePlusTheme } from '../JsObject/utrade-plus-theme';
import { OrderMode } from 'sharedweb/app.structs';
import { SHAREINDIA } from 'src/_vendors';
import { REST_BUILD } from './configuration';

export const ROOT_URL = environment.production
    ? `${window.location.origin}/` : 'http://10.0.0.90:61470/';

export const SERVER_URL = environment.production
    ? `${window.location.origin}/api/` : 'http://10.0.0.90:61470/api/';

export const REST_SERVER_URL = environment.production
    ? `${window.location.origin}/api/V2/` : 'http://10.0.0.118:40229/api/V2/';

export const SOCKET_URL = environment.production
    ? `${window.location.origin}/socket` : 'https://utestbe.shareindia.com/socket/';

export const CHART_SOCKET_URL = environment.production
    ? `${window.location.origin}/chart_socket` : 'https://utestbe.shareindia.com/chart_socket/';

export const EDIS_SERVER_URL = environment.production
    ? `${window.location.origin}/authorization/` : 'http://10.0.0.89:61470/authorization/';

export const ANALYTICS_SERVER_URL = environment.production
    ? `${window.location.origin}/` : 'https://betascan.utradesolutions.ai/analytics/';

export const APP_SECRET = (environment.production
    ? '==APP_SECRET_PLACEHOLDER_7gQOA4UqOn=='
    : 'e411c182-7c0c-11eb-9851-d4ae5297455f'
);
export const RECAPTCHA_REQUIRED = environment.production && !REST_BUILD;

export const OTP_EXPIRE_TIME = 30;

export const MOMENT_OPTION_FORMAT = 'DDMMMYY';

export const RESEND_ATTEMPTS = 3;

export const OTP_MAX_LENGTH = 6;

// In seconds.
export const SOCKET_INACTIVITY_TIMER = 60;

// GMT_IST_DIFFERENCE is the time in milli-seconds.
export const GMT_IST_DIFFERENCE = 19800 * 1000;

export const CURRENT_PLATFORMTYPE = PlatformType.WEB;

/**
 * In production mode, a placeholder will be set in place of dev environment RECAPTCHA KEY.
 */
export const CAPTCHA_SITEKEY = (environment.production
    ? '==RECAPTCHA_PLACEHOLDER_7gQOA4UqOn=='
    : '6LcXWq0UAAAAAGh2J9ZfWNz0tYIZBgZDcs5FgnMJ'
);

// export const NEWS_API_KEY = 'ab83917857b348c3ae65ebf348610e42';

export const CURRENT_VENDOR = 'Utrade-Plus';

export const PIN_LENGTH = 6;

export const LOGO_URL = '/assets/logo.png';

export const MSE_LOGO_URL = '/assets/mse/img/logo.png';

export const REG_EX = {
    id: '^[a-zA-Z0-9]+$',
    phone: '(\\+[\\d]{1,5}|0)?[7-9]\\d{9}',
    contains_special_char: '^[a-zA-Z0-9]+$',
    contains_mixed_case: '((?=.*[a-z])(?=.*[A-Z]))',
    contains_digit: '.*[0-9].*',
    hex_color: '^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$',
    integer_only: '^[0-9]*$',
    date: '/^\d{2}-\d{2}-\d{4}$/',
    timeRegex: '^(\d+):(\d+)(?::(\d+))?$' // HH:MM:SS or HH:MM
};

export const INDEXSYMBOL = {
    'NIFTY 50': 26000,
    'NIFTY BANK': 26009,
    'NIFTY FIN SERVICE': 26037,
    'NIFTY MIDCAP 50': 26014,
    'NIFTY NEXT 50': 26013,
    'SENSEX': 1,
    'BANKEX': 12,
    'SNSX50': 47
};

export const BSE_OC_ALLOWED_INDICES = ['SENSEX', 'BANKEX', 'SENSEX50', 'SNSX50'];

export const USE_EMAIL_ONLY = true;

export const SELECTED_VENDOR = SHAREINDIA;

export const EVENTS = {

    SYMBOL_CLICK: 'SYMBOL_CLICK',
    UPDATE_MTF_HOLDING_FEED: 'UPDATE_MTF_HOLDING_FEED',
    MARKET_ORDER_FORM_FILL: 'MARKET_ORDER_FORM_FILL',
    DEPTH_ORDER_FORM_FILL: 'DEPTH_ORDER_FORM_FILL',
    DELETE_MARKET_WATCH: 'DELETE_MARKET_WATCH',
    RENAME_MARKET_WATCH: 'RENAME_MARKET_WATCH',
    DELETE_INDICES: 'DELETE_INDICE',
    ADD_INDICES: 'ADD_INDICES',
    UPDATE_ORDER_BOOK_COLUMNS: 'UPDATE_ORDER_BOOK_COLUMNS',
    UPDATE_MARKET_WATCH_COLUMNS: 'UPDATE_MARKET_WATCH_COLUMNS',
    UPDATE_TRADE_BOOK_COLUMNS: 'UPDATE_TRADE_BOOK_COLUMNS',
    UPDATE_POSITIONS_COLUMNS: 'UPDATE_POSITIONS_COLUMNS',
    UPDATE_HOLDINGS_COLUMNS: 'UPDATE_HOLDINGS_COLUMNS',
    UODATE_PRODUCT_CONVERSION_SUMMARY: 'UPDATE_PRODUCT_CONVERSION_SUMMARY',
    UPDATE_BATCH_ORDERS_TABLE_COLUMNS: 'UPDATE_BATCH_ORDERS_TABLE_COLUMNS',
    ADD_SYMBOL: 'ADD_SYMBOL',
    UPDATE_USER_MAPPINGS: 'UPDATE_USER_MAPPINGS',
    ADD_TO_BATCH: 'ADD_TO_BATCH',
    MW_SELECT_EVENT: 'MW_SELECT_EVENT',
    CHANGE_ORDER_MODE: 'CHANGE_ORDER_MODE',
    LOG_OUT: 'LOG_OUT',
    LOGGED_IN: 'LOGGED_IN',
    MARKET_WATCHSETTINGS_CHANGE: 'MARKET_WATCHSETTINGS_CHANGE',
    ORDER_FORM_FOCUS_EVENT: 'ORDER_FORM_FOCUS_EVENT',
    SOCKET_CONNECTED: 'SOCKET_CONNECTED',
    NOTIFICATION_SETTINGS_UPDATE: 'NOTIFICATION_SETTINGS_UPDATE',
    UPDATE_ORDER_FORM_DATA: 'UPDATE_ORDER_FORM_DATA',
    WIDGET_VIEW_MODE: 'WIDGET_VIEW_MODE',
    PIN_SYMBOL: 'PIN_SYMBOL',
    OPEN_ORDER_ID: 'OPEN_ORDER_ID',
    PROFILE_PIC_UPLOAD: 'PROFILE_PIC_UPLOAD',
    MAXIMIZE_WIDGET_STATE: 'MAXIMIZE_WIDGET_STATE',
    UPDATE_HOLDINGS: 'UPDATE_HOLDINGS',
    CONFIRM_EDIS_STATUS: 'CONFIRM_EDIS_STATUS',
    CONFIRM_PLEDGE_STATUS: 'CONFIRM_PLEDGE_STATUS',
    SMART_MW_CHART: 'SMART_MW_CHART',
    UPDATE_IPO_BID_HISTORY: 'UPDATE_IPO_BID_HISTORY',
    UPDATE_FUNDS_REPORT: 'UPDATE_FUNDS_REPORT',
    SOCKET_AUTHENTICATED: 'SOCKET_AUTHENTICATED',
    UPDATE_MARKETWATCH_FEED: 'UPDATE_MARKETWATCH_FEED',
    UPDATE_HOLDING_FEED: 'UPDATE_HOLDING_FEED',
    UPDATE_MTF_HOLDING_Z: 'UPDATE_MTF_HOLDING_Z',
    UPDATE_POSITIONS_FEED: 'UPDATE_POSITIONS_FEED',
    UPDATE_ORDER_FEED: 'UPDATE_ORDER_FEED',
    UPDATE_BATCH_FEED: 'UPDATE_BATCH_FEED',
    UPDATE_TRADE_FEED: 'UPDATE_TRADE_FEED',
    UPDATE_GTT_FEED: 'UPDATE_GTT_FEED',
    UPDATE_SUPER_BOOK_FEED: 'UPDATE_SUPER_BOOK_FEED',
    UPDATE_SMART_BOOK_FEED: 'UPDATE_SMART_BOOK_FEED',
    FO_BANNED_SYMBOLS_FEED: 'FO_BANNED_SYMBOLS_FEED',
    CHECK_INTERNET: 'CHECK_INTERNET',
    WHATS_NEW_TABS: 'WHATS_NEW_TABS',
    WHATS_NEW_FLAG: 'WHATS_NEW_FLAG',
    MINIMIZE_TRADING_TABS: 'MINIMIZE_TRADING_TABS',
    DASH_TAB_CHANGED: 'DASH_TAB_CHANGED',
    DASH_TAB_UPDATES: 'DASH_TAB_UPDATES',
    DASH_TAB_CHANGED_BOOK: 'DASH_TAB_CHANGED_BOOK',
    DASH_TAB_UPDATES_BOOK: 'DASH_TAB_UPDATES_BOOK',
    SHOW_TRIGGERED_WIDGETS: 'SHOW_TRIGGERED_WIDGETS',
    UPDATE_POSITION_SUMMARY_FEED: 'UPDATE_POSITION_SUMMARY_FEED',
    UPDATE_POSITION_CHART_FEED: 'UPDATE_POSITION_CHART_FEED',
    UPDATE_HOLDING_SUMMARY_FEED: 'UPDATE_HOLDING_SUMMARY_FEED',
    POSITIONS_DATA_FETCHED: 'POSITIONS_DATA_FETCHED',
    UPDATE_BREAKDOWN: 'UPDATE_BREAKDOWN',
    UPDATE_MUTUAL_FUNDS: 'UPDATE_MUTUAL_FUNDS',
    CHART_LOADED: 'CHART_LOADED',
    UPDATE_ANALYTICS_CHART: 'UPDATE_ANALYTICS_CHART',
    UPDATE_FUNDAMENTALS: 'UPDATE_FUNDAMENTALS',
    RISK_DISCLOSURE_POPUP: 'RISK_DISCLOSURE_POPUP',
    CLOSE_ORDER_FORM: 'CLOSE_ORDER_FORM',
    UPDATE_SCREENER_SYMBOLS_FEED: 'UPDATE_SCREENER_SYMBOLS_FEED',
    ANALYTICS_SYMBOL_UPDATED: 'ANALYTICS_SYMBOL_UPDATED',
    UPDATE_PEER_SYMBOLS_FEED: 'UPDATE_PEER_SYMBOLS_FEED',
    STOCK_SIP_DIALOG: 'STOCK_SIP_DIALOG',
    UPDATE_INDEX_STOCK_DATA: 'UPDATE_INDEX_STOCK_DATA',
    AMOTIMING_UPDATE: 'AMOTIMING_UPDATE',
    WIDGET_BOX_TAB_CHANGED: 'WIDGET_BOX_TAB_CHANGED',
    OPEN_AUTHORIZATION_DIALOG: 'OPEN_AUTHORIZATION_DIALOG',
    PAYOUT_PARAM_UPDATE: 'PAYOUT_PARAM_UPDATE'
}

export const SERVER_DISCONNECTION = {
    HFTDMS: 'HFTDMSDISCONNECTED',
    GOSERVER: 'GOSERVER',
    WEBSERVER: 'WEBSERVER',
    MDL: 'MDL',
    SNAPSHOTS: 'SNAPSHOTS'
}

export const LOCAL_STORAGE_KEYS = {
    userInfo: 'USER_INFO',
    restUserInfo: 'REST_USER_INFO',
    lastClickedSymbol: 'LAST_CLICKED_SYMBOL',
    messages: 'MESSAGES',
    userBook: 'USER_BOOK',
    selectedMarketWatch: 'SELECTED_MARKET_WATCH',
    selectedMarketWatchId: 'SELECTED_MARKET_WATCH_ID',
    defaultMarketWatch: 'DEFAULT_MARKET_WATCH',
    themeSelected: 'THEME_SELECTED',
    widget: 'Widget',
    defaultProduct: 'DEFAULT_PRODUCT',
    deviceId: 'DEVICE_ID',
    popupAccepted: 'RISK_POPUP',
    nominationPopupAccepted: 'NOMINATION_POPUP',
    totpUserInfo: 'TOTP_USER_INFO',
    deltaValue: 'DELTA_VALUE',
    lastLoggedInUser: 'LAST_LOGGED_IN_USER',
    whatsNewId: 'WHATS_NEW_ID',
    activeTab: 'ACTIVE_TAB',
    tradingViewInterval: 'TRADING_VIEW_INTERVAL',
    lastSubTabClicked: 'LAST_SUB_TAB_CLICKED',
};

export const CACHE_KEYS = {
    lastClickedSymbol: 'LAST_CLICKED_SYMBOL',
    defaultFormSettings: 'DEFAULT_FORM_SETTINGS_MOBILE',
    defaultMarketWatch: 'DEFAULT_MARKET_WATCH',
    notificationSettings: 'NOTIFICATIONS_SETTINGS',
    selectedLayout: 'SELECTED_LAYOUT',
    orderBook: 'orderBook',
    tradeBook: 'tradeBook',
    positions: 'positions',
    holdings: 'holdings',
    productConversionSummary: 'productConversionSummary',
    batchOrdersTable: 'batchOrdersTable',
    chartingType: 'CHARTING_TYPE',
    marketWatchOrder: 'MARKET_WATCH_ORDER',
    marketWatchSettings: 'MARKET_WATCH_SETTINGS',
    fundsBook: 'fundsBook',
    currentTheme: 'currentTheme',
    pinnedSymbol: 'pinnedSymbol',
    widget: 'Widget',
    UPIId: 'UPI_ID',
    whatsNew: 'WHATS_NEW',
    SortingData: 'SORTING_DATA',
    depositUpiId: 'DEPOSIT_UPI_ID',
};

export const VISUAL_COMPONENTS = {
    dashboard: 'DashBoard',
    messageBar: 'MessageBar',
    orderForm: 'OrderForm',
    orderDepth: 'OrderDepth',
    marketWatch: 'MarketWatch',
    orderBook: 'OrderBook',
    tradeBook: 'TradeBook',
    positions: 'Positions',
    holdings: 'Holdings',
    userMarginSummary: 'UserMargin',
    indices: 'Indices',
    marginSummary: 'MarginSummary',
    productConversionSummary: 'ProductConversionSummary',
    charting: 'Charting',
    tweets: 'Tweets',
    news: 'News',
    depthScalper: 'DepthScalper',
    optionCalc: 'OptionCalc',
    batchOrderTable: 'BatchTable',
    marketSession: 'MarketSession',
    funds: 'Funds',
    marketPicture: 'MarketPicture',
    userBooks: 'UserBooks',
    marketAnalytics: 'MarketAnalytics',
    smartMW: 'smartMW',
    sideBar: 'sideBar'
};

export const PRICE_TYPE_REDUCER = {
    absolute: 'Abs',
    tick: 'Ticks'
};

export const ENV_CONFIG = {
    useRadioOrderModeTab: true,
    disclosedQtyDisabledMarkets: [
        'MSEFO',
        'MSECD'
    ],
    handledMarketConnectivity: [
        'MSECD',
        'MSEFO',
        'MSECM',
        'ESMNSE'
    ],
    maxPriceAllowed: 1000000,
    maxQtyAllowed: 9999999,
    defaultPasswordPolicy: {
        contains_digit: true,
        contains_mixed_case: true,
        contains_special_char: true,
        max_length: 12,
        min_length: 8,
        otp_retries_allowed: 5,
    },
    defaultChart: 'echarts'
};

export const TIMESTAMP_TO_HOURS_FACTOR = 1000 * 3600 * 24 * 365;

export const FIRST_TIME_DEFAULT_ORDER_SETTINGS = {
    orderMode: OrderMode.Buy,
    orderValidity: OrderValidity.DAY,
    orderType: OrderType.Limit,
    product: ProductType.carryforward,
    quantity: 1,
    price: 0,
    triggerPrice: 0,
    discloseQty: 0,
    trailingPrice: 0
};


export const CHART_TYPE_DATA = {
    trading_view: {
        image: 'assets/images/tradingView.svg',
        name: 'Trading View'
    },

    chartiq: {
        image: 'assets/images/chartIQ.png',
        name: 'Chart IQ'
    }
};

export const DEFAULT_NEWS_TWITTER_SYMBOL = {
    symbolName: 'SENSEX',
    symbolId: 100200001169224,
    market: 'BSECM',
    securityId: 532985
};

// Widget state mapping that defines if the widget is minimised, All widgets are maximised by default.
export const FLUID_WIDGETS_STATE = {
    marketPicture: WidgetViewMode.DEFAULT,
    chart: WidgetViewMode.DEFAULT,
    optionChain: WidgetViewMode.DEFAULT,
    userBooks: WidgetViewMode.DEFAULT
};

export const USERBOOKNAMES = ['Order Book', 'Trade Book', 'GTT Book', 'Positions', 'Margin', 'Holding', 'Product Conversion Summary'];

export const KYC_BUISSNESS_UID = '4fef03cc-cbda-11e9-97c9-42010a800003';

export const DEFAULT_CURRENCY = 'INR';

export const DEFAULT_LOCALE = 'en-IN';

export const DIFFERENT_LAYOUT_VENDORS = ['MSE', 'SKY'];

export const DATE_TIME_FORMAT_UTILITY = 'M/D/YY, h:mm a';
export const DATE_TIME_FORMAT_UTILITY_II = 'DD-MMM-YYYY';
export const SIP_DATE_FORMAT = 'dddd';

export const DEFAULT_PINNED_SYMBOLS = [
    {
        symbol_id: 100300000026000,
        symbol: 'Nifty 50',
        is_index: true,
        marketId: 'NSECM',
        security_id: 26000
    },
    {
        symbol_id: 100100000000001,
        symbol: 'Sensex',
        is_index: true,
        marketId: 'BSECM',
        security_id: 1
    }
];

export const EOD_TIME = {
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999,
};

export const NAME_LENGTH_STYLING = 32;

// In milliseconds.
export const FIREBASE_FETCH_TIMEOUT = 5000

export const MAX_BIDS = 3;

export const LOGGING_CONFIGURATIONS = {
    helper_logs: false,
    quote_logs: false
};

export const DEFAULT_CHARTIQ_INTERVAL = {
    periodicity: 1,
    interval: 1,
    timeUnit: 'minute'
}

export const CHARTIQ_BASE_KEY = 'myChartLayout';
export const PRIORITY_CM_MARKETS = ['NSECM', 'BSECM', 'MSECM'];

export const COUNTDOWN_TIMER = 10 * 60;

// To Show the date of before 7 days from the current date. 
export const FUNDS_TRANSACTION_INITIAL_GAP = 7;

// In milliseconds
export const NET_STATUS_DELAY = 5000;

export const minScheduledTime = '09:00:00';
export const maxScheduledTime = '15:29:59';

// Pre Defined Scheduled Time Options.
export const scheduledTimeOptions = [
    { label: '9:30:00 AM', value: '9:30:00 AM' },
    { label: '10:30:00 AM', value: '10:30:00 AM' },
    { label: '11:30:00 AM', value: '11:30:00 AM' },
    { label: '12:30:00 PM', value: '12:30:00 PM' },
    { label: '01:30:00 PM', value: '1:30:00 PM' },
    { label: '02:30:00 PM', value: '2:30:00 PM' },
    { label: '03:29:00 PM', value: '3:29:00 PM' },
    { label: 'Set Custom Time', value: 'custom' }
];

export const minCustomTime = '09:30:00';
export const IPO_MAINBOARD_LABEL = 'BB';
export const BOOKS_PAGE_SIZE = 50;

export const IS_SMART_ENABLED_DEFAULT = true;

export const defaultMarketStartTime = '09:15:00';
export const defaultMarketEndTime = '15:15:00';
export const minSmartInterval = 10;
export const maxSmartIntervalSeconds = 21600; //time btw default market open and close
export const minMarketVolumePercentage = 10;
export const maxDepthAllowed = 5;
export const minIcebergOrders = 2;
export const maxIcebergOrders = 20;
export const minSmartOrderValue = 100000;
export const minSmartLots = 5;